import { useRef } from "react";
import { useContext } from "react";
import { ServicesContext } from "../contexts";
import { useNavigate } from "react-router";
import useTranslation from "./useTranslation";
import { AppContext } from "../contexts";
import { determineView, stampWorkOrderRef } from "../utils";

function useDirectLogin(defaultConfirmationNumber){
    const { current: haveExpiry } = useRef(new URLSearchParams(window.location.search).get('have_expiry'));
    const { getNewLink, fetchAppointmentDetailsDirectLogin } = useContext(ServicesContext);
    const { setAppointmentData } = useContext(AppContext);
    const navigate = useNavigate();
    const { i18n } = useTranslation();

    const handleDirectLoginLogin = async () => {
        try{
              const {  status, bookingDetails} = await fetchAppointmentDetailsDirectLogin(defaultConfirmationNumber);
              if(!status){
                navigate('/message', {
                  state: {
                    title:  i18n('cp_link_expired'),
                    copy:   i18n('cp_request_new_access'),
                    status: false, 
                    errorMessage: i18n('request_new_email'),
                    newlink: true,
                    callBackFunc : ()=>getNewLink(defaultConfirmationNumber)
                  }
                });
              }else{
                setAppointmentData(bookingDetails);
                stampWorkOrderRef(bookingDetails);
                navigate(determineView(bookingDetails));
              }
        }
        catch(error){
          console.error('An error occurred:', error);
        }
    };

    const directLoginCheck = () => {
      if(haveExpiry === 'true'){
        handleDirectLoginLogin();
      }
    }

    return {
      directLoginCheck
    }
}
export default useDirectLogin;